import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import { MobileStickyCta } from "./MobileStickyCta";

export default function Layout() {
    const { pathname } = useLocation();

    // Reset scroll on route change
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    // Minimal header on simulator pages (user requirement)
    const headerVariant = pathname.startsWith("/simulateur") ? "simulator" : "default";

    return (
        <div className="min-h-screen flex flex-col bg-sand text-grey-text">
            <Header variant={headerVariant} />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            {headerVariant === "default" && <MobileStickyCta />}
            <CookieBanner />
        </div>
    );
}
